<template>
    <!-- we need to wait until region has bee loaded to display the app -->
    <div
        v-show="region"
        id="app"
        class="relative flex flex-col min-h-screen"
        :class="{
            'blue-glow': !$route.meta.hideNavigationGlow
        }"
    >
        <navigation v-if="!$route.meta.hideNavigation"></navigation>

        <router-view class="flex-grow" />

        <foot v-if="!$route.meta.hideFooter"></foot>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Navigation from "./components/Navigation";
import Foot from "./components/Foot";

export default {
    name: "app",

    components: { Navigation, Foot },

    created() {
        this.$store.dispatch("FETCH_CONFIG");
    },

    computed: {
        ...mapState({
            region: state => state.region
        })
    },

    watch: {
        region(region) {
            let currentRoute = this.$route;
            let countryCode = region.data.code;

            if (
                region.status == "false" &&
                currentRoute.name != "region-lock" &&
                !currentRoute.meta.unlock
            ) {
                this.$router.push({ name: "region-lock" });

            } else if (
                !currentRoute.params.country ||
                currentRoute.params.country != countryCode
            ) {
                currentRoute.params.country = countryCode;

                this.$router.push(currentRoute);
            }
        }
    }
};
</script>

<style scoped>
.blue-glow:before {
    content: "";
    background-image: url("~@/assets/img/2020/navigation_bg.png");
    background-size: 100% 100px;
    background-position: top center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    z-index: 2;
    pointer-events: none;
}
</style>
